import styled from 'styled-components';

// One row of the chart click menu. Shared by the metric rows and the Insights
// "Explain this value" row so they read as one list.
const Option = styled.div`
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 3px;

  &:hover {
    background-color: var(--color-bg-hover);
  }
`;

export default Option;
